<div class="patients-container">
  <div class="patients-search">
    <div fxLayout="column" fxLayoutAlign="" fxFlex="17" class="patients-search-input">
      <input matInput [placeholder]="'Document ID' | translate" [(ngModel)]="documentID">
    </div>
    <div fxLayout="column" fxLayoutAlign="" fxFlex="17" class="patients-search-input">
      <input matInput [placeholder]="'First name' | translate" [(ngModel)]="firstName">
    </div>
    <div fxLayout="column" fxLayoutAlign="" fxFlex="17" class="patients-search-input">
      <input matInput [placeholder]="'Last name' | translate" [(ngModel)]="lastName">
    </div>
    <div fxLayout="column" fxLayoutAlign="" fxFlex="17" class="patients-search-input">
      <input matInput [placeholder]="'Date of birth' | translate" type="date" [(ngModel)]="dateOfBirth"
        [max]="getCurrentDate()">
      </div>
      <div fxLayout="column" fxLayoutAlign="" fxFlex="32" class="patients-search-buttons">
        <div fxLayout="row" fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="" fxFlex="47">
            <button class="search-button" (click)="searchPatientsForm()">
              <mat-icon>search</mat-icon>
              <div class="btn-text">{{"Search" | translate}}</div>
            </button>
          </div>
          <div fxFlex="6"></div>
          <div fxLayout="column" fxLayoutAlign="" fxFlex="47">
            <button class="register-button" (click)="registerPatient()"><mat-icon>add</mat-icon>
            <div class="btn-text">{{"Register Patient" | translate}}</div>
          </button>
        </div>
        <!-- <div fxLayout="column" fxLayoutAlign="" fxFlex="47">
        <button class="clear-button" (click)="clearPatientsForm()"><mat-icon>clear</mat-icon>
        <div>Clear</div>
      </button>
    </div> -->
  </div>
</div>
</div>

<div class="patients-table">
  <mat-table [dataSource]="data" class="mat-elevation-z8 ">

    <ng-container matColumnDef="documentNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'Document Number' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.documentNumber || "-"}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'First name' | translate }}
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element"> {{element.firstName || "-"}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'Last name' | translate }}
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element"> {{element.lastName || "-"}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="dateOfBirth">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'Date of birth' | translate }}
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element"> {{formatDate(element.dateOfBirth) || "-"}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>
        {{ 'Actions' | translate }}
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <button class="action-button" (click)="openVisit(element)" [disabled]="isLoading">{{ 'View' |
        translate }}</button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
  <!-- <div fxLayout="row" [ngClass]="data.data.length!==0 ? 'patients-content-paginator-hide' : ''">
  <div fxLayout="col" fxFlex="100" style="margin-top: 3em; justify-content: center;">Search for Patients!</div>
</div> -->
<mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons
  [ngClass]="data.data.length===0 ? 'patients-content-paginator-hide' : ''" (page)="pageChange()"
  [length]="totalRecords" />
</div>
</div>

<!-- VISIT SELECTION -->
<nz-modal nzNoAnimation #visitModalRef nzSize [(nzVisible)]="isVisitVisible"
  [nzTitle]="('Visit' | translate) + ' ' + selectedPatientFullName" (nzOnCancel)="handleVisitCancel()"
  nzCancelText="Cancel" nzOkText="Save" nzOkType="primary" [nzFooter]="null" class="custom-modal-class">
  <ng-container *nzModalContent>
    <div class="form-row" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="center center" fxFlex="50">
        <div class="visit-icons" fxLayout="column" [ngClass]="{'active-option':isNewSelected}"
          (click)="selectNewVisit()">
          <div class="visit-label">{{"Create New Visit" | translate}}</div>
          <i nz-icon [nzType]="isNewSelected ? 'icons:plus-color' : 'icons:plus'" class="visit-icon"></i>
        </div>
      </div>
      @if (!!existingVisits && existingVisits.length > 0) {
        <div fxLayout="column" fxLayoutAlign="center center" fxFlex="50"
          >
          <div class="visit-icons" fxLayout="column" [ngClass]="{'active-option':!isNewSelected}"
            (click)="selectDraftVisit()">
            <div class="visit-label">{{"Select an existing Draft Visit" | translate}}</div>
            <i nz-icon [nzType]="!isNewSelected ? 'icons:archive-color' : 'icons:archive'"
            class="visit-icon"></i>
          </div>
        </div>
      }
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      @if (!!existingVisits && existingVisits.length > 0) {
        <div fxLayout="column" fxLayoutAlign="center start" fxFlex="50"
          >
          <nz-select class="draft-select" nzShowSearch nzAllowClear
            [nzPlaceHolder]="'Select an existing Draft Visit' | translate" [nzLoading]="isVisitLoading"
            style="width: 100%" [visible]="!isNewSelected" [(ngModel)]="draftVisit">
            @for (visit of existingVisits; track visit) {
              <nz-option
                [nzLabel]="formatDate(visit.date?.toString()) + ' ' + (visit?.notes ? ' | ' + visit.notes : '') "
              [nzValue]="visit.id"></nz-option>
            }
          </nz-select>
        </div>
      }
    </div>

    <div fxLayout="row" fxLayoutAlign="end" class="footer">
      <button nz-button nzPrimary class="save-btn" type="submit" [nzLoading]="isVisitLoading"
        [disabled]="isVisitLoading" (click)="handleVisitSubmit()" [disabled]="!isNewSelected && !draftVisit">
        {{ "Visit" | translate }}
      </button>
      <button nz-button nzDanger class="cancel-btn" type="button" (click)="handleVisitCancel()"
        [disabled]="isVisitLoading">
        {{ "Cancel" | translate }}
      </button>
    </div>
  </ng-container>
</nz-modal>